<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="物料编码"><el-input v-model="query.materialCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="物料名称"><el-input v-model="query.materialName" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="范围">
        <el-select v-model="query.boardScope" size="small" style="width:120px">
          <el-option label="待发布" value="pending" />
          <el-option label="已发布" value="released" />
          <el-option label="全部" value="all" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmItem:list')" type="primary" size="small" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="materialCode" label="物料编码" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="materialName" label="物料名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="lifecycleStatus" label="生命周期" width="130" header-align="center" align="center">
        <template slot-scope="scope">
          <el-select
            v-if="isAuth('plm:plmItem:update') || isAuth('plm:plmItem:release')"
            :value="scope.row.lifecycleStatus || 'concept'"
            size="mini"
            :disabled="scope.row.lifecycleStatus === 'released'"
            @change="v => changeLifecycle(scope.row, v)"
          >
            <el-option v-for="opt in lifecycleOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
          <span v-else>{{ lifecycleLabel(scope.row.lifecycleStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="defaultMbomVersion" label="MBOM版本" width="90" header-align="center" align="center" />
      <el-table-column prop="hasReleasedMbom" label="已发布MBOM" width="100" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.hasReleasedMbom === '1' ? 'success' : 'info'" size="mini">{{ scope.row.hasReleasedMbom === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="blockReason" label="阻塞原因" min-width="160" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column label="操作" width="220" header-align="center" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="isAuth('plm:plmItem:release')" type="text" size="small" :disabled="scope.row.canRelease !== '1'" @click="releaseProduct(scope.row)">发布量产</el-button>
          <el-button v-if="isAuth('plm:plmItem:release')" type="text" size="small" @click="openMbomRelease(scope.row)">发布MBOM</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog title="发布 MBOM 版本" :visible.sync="mbomDialogVisible" width="min(400px, calc(100vw - 24px))">
      <el-form label-width="100px">
        <el-form-item label="物料"><span>{{ mbomForm.materialCode }} {{ mbomForm.materialName }}</span></el-form-item>
        <el-form-item label="BOM版本"><el-input v-model="mbomForm.bomVersion" placeholder="如 V1" /></el-form-item>
        <el-form-item><span class="hint-text">须先在 MBOM 管理中审批通过该版本</span></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="mbomDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="mbomSubmitting" @click="submitMbomRelease">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'PlmItem',
  data() {
    return {
      query: { materialCode: '', materialName: '', boardScope: 'pending' },
      list: [], pageIndex: 1, pageSize: 20, loading: false, permCodes: [],
      mbomDialogVisible: false, mbomSubmitting: false, mbomForm: {},
      lifecycleOptions: [
        { value: 'concept', label: '概念' }, { value: 'design', label: '设计' }, { value: 'pilot', label: '试制' },
        { value: 'released', label: '量产' }, { value: 'eol', label: '停产' }, { value: 'obsolete', label: '废止' }
      ],
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' }
    }
  },
  computed: {
    total() { return this.list.length },
    pageList() { return this.list.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    lifecycleLabel(v) {
      const map = { concept: '概念', design: '设计', pilot: '试制', released: '量产', eol: '停产', obsolete: '废止' }
      return map[v] || v || '-'
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.post('/plm/item/releaseBoard', this.query).then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    changeLifecycle(row, status) {
      if (!row || !row.materialId || status === row.lifecycleStatus) return
      const label = this.lifecycleLabel(status)
      this.$confirm('确认将生命周期改为「' + label + '」?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/item/updateLifecycle', { materialId: row.materialId, lifecycleStatus: status }).then(() => {
          this.$message.success('已更新'); this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    releaseProduct(row) {
      this.$confirm('确认发布量产?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/item/releaseProduct', { materialId: row.materialId }).then(() => {
          this.$message.success('发布成功'); this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    openMbomRelease(row) {
      this.mbomForm = { materialId: row.materialId, materialCode: row.materialCode, materialName: row.materialName, bomVersion: row.defaultMbomVersion || 'V1' }
      this.mbomDialogVisible = true
    },
    submitMbomRelease() {
      this.mbomSubmitting = true
      request.post('/plm/item/releaseMbom', { materialId: this.mbomForm.materialId, bomVersion: this.mbomForm.bomVersion })
        .then(() => { this.$message.success('MBOM 已发布'); this.mbomDialogVisible = false; this.load() })
        .catch(() => {}).finally(() => { this.mbomSubmitting = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.hint-text { color: #909399; font-size: 12px; }
</style>
